import React, { Component } from 'react';

class AppLayout extends Component {
    componentDidMount() {

    }
    render() {
        return (
            <div className="full-height">
                {this.props.children}
            </div>
        );
    }
}

export default AppLayout;